import { User } from "firebase/auth";
import { IIllustrokeUser, IUserRequest } from "../../types";

function setUserAction(user: User | null) {
  return {
    type: 'SET_USER_FIREBASE',
    payload: user
  };
}

function setUserInfoAction(userInfo: IIllustrokeUser | null) {
  return {
    type: 'SET_USER_INFO',
    payload: userInfo
  };
}

function setUserTokenAction(token: string) {
  return {
    type: 'SET_USER_TOKEN',
    payload: token
  };
}

function addUserRequestAction(value: IUserRequest) {
  return {
    type: 'ADD_USER_REQUEST',
    payload: value
  };
}

function setUserRequestsInitializedAction(value: boolean) {
  return {
    type: 'SET_USER_REQUESTS_INITIALIZED',
    payload: value
  };
}

function editUserRequestAction(value: IUserRequest) {
  return {
    type: 'EDIT_USER_REQUEST',
    payload: value
  };
}

function deleteUserRequestAction(value: IUserRequest) {
  return {
    type: 'DELETE_USER_REQUEST',
    payload: value
  };
}

function deleteAllUserRequestAction() {
  return {
    type: 'DELETE_ALL_USER_REQUEST',
    payload: null
  };
}

function setColorPickerLastChoices(colors: string[]) {
  return {
    type: 'SET_COLOR_PICKER_LAST_CHOICES',
    payload: colors
  };
}

function addColorPickerLastChoices(value: string) {
  return {
    type: 'ADD_COLOR_PICKER_LAST_CHOICES',
    payload: value
  };
}

function changeUserTokensByXAction(value: number) {
  return {
    type: 'CHANGE_USER_TOKENS_BY_X',
    payload: value
  };
}

function setColorPalette(value: string) {
  return {
    type: 'SET_COLOR_PALETTE',
    payload: value
  };
}

function setColorLimit(value: number) {
  return {
    type: 'SET_COLOR_LIMIT',
    payload: value
  };
}

function setCopyStyleReferenceUrls(value: string[]) {
  return {
    type: 'SET_COPY_STYLE_REFERENCE_URLS',
    payload: value
  };
}

function addCopyStyleReferenceUrl(value: string) {
  return {
    type: 'ADD_COPY_STYLE_REFERENCE_URL',
    payload: value
  };
}

export {
  setUserAction,
  setUserTokenAction,
  setUserInfoAction,
  addUserRequestAction,
  addColorPickerLastChoices,
  setColorPickerLastChoices,
  editUserRequestAction,
  deleteUserRequestAction,
  changeUserTokensByXAction,
  deleteAllUserRequestAction,
  setUserRequestsInitializedAction,
  setColorPalette,
  setColorLimit,
  addCopyStyleReferenceUrl,
  setCopyStyleReferenceUrls
}